import React from "react"
import { Button, Checkbox, Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import AddCustomerDocumentModal from "./AddCustomerDocumentModal"
import PreviewCustomerDocument from "./PreviewCustomerDocument"

export default class CustomerDocumentTable extends React.Component {

  state = {
    show: false,
    showInfo: false,
    item: {},
  }

  centerCenter = 'align-center v-center'

  centerClickable = `${ this.centerCenter } cursor-pointer`

  renderTh = (name, title) => <th className={ this.centerCenter } title={ title }><small>{ name }</small></th>

  renderTd = (item, content) => <td className={ this.centerClickable }
    onClick={_ => this.showInfo(item) }>{ content }</td>

  showInfo = item => this.setState({ showInfo: true, item })

  closeShowInfo = () => this.setState({ showInfo: false })

  removeCurrentItem = (removeCustomerDocument) => {
    if(removeCustomerDocument(this.state.item.label)) {
      this.closeShowInfo()
    }
  }

  render() {

    const { customerDocuments, removeCustomerDocument, running } = this.props

    const data = customerDocuments.map((item, index) => <tr key={`customerInfo-${index}`}
      title="Click to preview">
      { this.renderTd(item, item.label) }
      { this.renderTd(item, <small>{ item.imageType }</small>) }
      { this.renderTd(item, <Checkbox checked={ item.mandatory } readOnly></Checkbox>) }
      <td className={ this.centerCenter }>
        <span className="red cursor-pointer"
          onClick={() => removeCustomerDocument(item.label)}>
          <FontAwesome name="trash" title='Delete' />
        </span>
      </td>
    </tr>)

    return (
      <div>
        <Table striped bordered condensed hover responsive>
          <thead>
            <tr>
              { this.renderTh('LABEL') }
              { this.renderTh('IMAGE TYPE') }
              { this.renderTh('REQUIRED', 'The field is mandatory?') }
              { this.renderTh('Action') }
            </tr>
          </thead>
          <tbody>
            { data }
            <tr>
              <td className={ `${this.centerCenter} p-10` } colSpan={7}>
                <Button bsStyle="default" title='Add new customer document'
                  disabled={ running }
                  onClick={_ => this.setState({ show: true })}>
                  <FontAwesome name="plus" /> Add new field
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>

        <AddCustomerDocumentModal
          show={ this.state.show }
          close={() => this.setState({ show: false }) }
          addDocument={ this.props.addDocument }
          documentExists={ this.props.documentExists }
        />

        <PreviewCustomerDocument
          show={ this.state.showInfo }
          close={() => this.closeShowInfo()}
          data={ this.state.item }
          remove={() => this.removeCurrentItem(removeCustomerDocument)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/CustomerDocumentTable.js